import { getPointerData } from './get-pointer-data';
/**
 * Get pointer/finger position
 */
export function getPosition(evt) {
    var data = getPointerData(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map


//////////////////
// WEBPACK FOOTER
// /data/websites/bestcompany1982.it/httpdocs/wp-content/themes/g2k-theme-2/node_modules/smooth-scrollbar/utils/get-position.js
// module id = 99
// module chunks = 0